var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivacyShieldIcon = function SvgPrivacyShieldIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "M9.075 9.935V8.034c0-1.064.862-1.94 1.925-1.94s1.925.876 1.925 1.94v1.9m-1.92-9.3c1.13.554 8.795 4.737 8.795 5.996v6.617c0 4.103-4.91 7.529-7.395 9a2.74 2.74 0 0 1-2.81 0c-2.485-1.471-7.396-4.897-7.396-9V6.63c0-1.259 7.675-5.442 8.806-5.997M8.8 16.208c-.608 0-1.1-.702-1.1-1.569v-4.285s.492-.42 1.1-.42h4.4c.607 0 1.1.42 1.1.42v4.285c0 .867-.493 1.569-1.1 1.569H8.8"
  })));
};
export default SvgPrivacyShieldIcon;